import * as React from "react";
import styled from "styled-components";
import { GraphWrapArea } from "../../common";
import { ExecutiveReportDataV3 } from "../../../../../../../server/types/request/report/exective";
import { Button } from "react-bootstrap";
import { ElementEvaluation } from "../../../../../../../server/models/graph/element-evaluation";
import { OneNumberScore } from "../../exective-report/one-number-score";
import { OneNumberScoreDetail } from "../../exective-report/one-number-score-detail";
import { ImpressionEvaluation } from "../../exective-report/impression-evaluation";
import { ActionStandard } from "./action-standard";
import { PotentialDemand } from "./potential-demand";
import { v3ApiEndpoint } from "../../../../../../../server/router/endpoint";

const GraphPanel = styled.div`
	width: 100%;
`;
export const GraphCard = styled.div`
	vertical-align: top;
	min-width: 500px;
	display: inline-block;
`;
const ButtonArea = styled.div`
	button {
		margin: 0px 10px;
	}
`;

export type ExecutiveReportPageProps = ExecutiveReportDataV3 & {
	goalSalesVolume: number;
	onSimulationPage: () => void;
	evaluations: ElementEvaluation[];
};

export const ExecutiveReportLatestPage = React.memo((props: ExecutiveReportPageProps) => {
	const { demandForecast, oneNumberScoreNorm, goalSalesVolume, oneNumberScores, onSimulationPage, job, evaluations } =
		props;
	const hasDemandForecast = demandForecast.length > 0;
	return (
		<GraphWrapArea>
			<ButtonArea>
				<Button
					as="a"
					download
					href={`${v3ApiEndpoint.downloadExecutiveReport}/${job._id}`}
					variant={"outline-secondary"}
					size={"sm"}
				>
					Download
				</Button>
				{hasDemandForecast && (
					<Button variant={"outline-secondary"} size={"sm"} onClick={onSimulationPage}>
						補整＆提案フォーマット
					</Button>
				)}
			</ButtonArea>
			<GraphPanel>
				<GraphCard>
					<ActionStandard
						job={job}
						evaluations={evaluations}
						demandForecast={demandForecast}
						oneNumberScoreNorm={oneNumberScoreNorm}
						oneNumberScores={oneNumberScores}
						goalSalesVolume={goalSalesVolume}
					/>
				</GraphCard>
				<GraphCard>
					{hasDemandForecast && (
						<PotentialDemand
							/**
						jobCode={job.jobNum}
						salesVolumePrediction={salesVolumePrediction}
						 */
							job={job}
							demandForecast={demandForecast}
							goalSalesVolume={goalSalesVolume}
						/>
					)}
				</GraphCard>
			</GraphPanel>
			<GraphPanel>
				{oneNumberScoreNorm && (
					<GraphCard>
						<OneNumberScore job={job} oneNumberScores={oneNumberScores} oneNumberScoreNorm={oneNumberScoreNorm} />
					</GraphCard>
				)}
				<GraphCard>
					<OneNumberScoreDetail oneNumberScores={oneNumberScores} />
				</GraphCard>
			</GraphPanel>
			<GraphPanel>
				<ImpressionEvaluation job={job} evaluations={evaluations} />
			</GraphPanel>
		</GraphWrapArea>
	);
});
